module.exports = __webpack_public_path__ + "static/media/film-production-grid-5.820f9214.jpg";